import type { AnimationPrefetchContext } from "@/layers";
import { type TimeState, TimeStates } from "@/models/time-control/timeStateTypes";
import { isAnimationModeOpts } from "@/models/time-control/timeTypeGuard";
import { setTimeList } from "@/time";
import { Interval } from "luxon";

type AnimationWindowConfig = Pick<AnimationPrefetchContext, "windowStart" | "windowEnd" | "temporalResolution">;

let currentAnimationPrefetchContext: AnimationPrefetchContext | null = null;

export function buildAnimationPrefetchContext({
  windowStart,
  windowEnd,
  temporalResolution,
}: AnimationWindowConfig): AnimationPrefetchContext {
  const interval = Interval.fromDateTimes(windowStart, windowEnd);
  const frameTimestamps = setTimeList(interval, temporalResolution);

  return {
    windowStart,
    windowEnd,
    temporalResolution,
    frameTimestamps,
    windowKey: [
      windowStart.toUTC().toISO(),
      windowEnd.toUTC().toISO(),
      temporalResolution.toISO(),
      frameTimestamps.length,
    ].join("|"),
  };
}

export function setCurrentAnimationPrefetchContext(animationPrefetchContext: AnimationPrefetchContext | null) {
  currentAnimationPrefetchContext = animationPrefetchContext;
}

export function getCurrentAnimationPrefetchContext() {
  return currentAnimationPrefetchContext;
}

export function syncCurrentAnimationPrefetchContextForTimeState(timeState: Pick<TimeState, "matches" | "context">) {
  if (timeState.matches(TimeStates.ANIMATION) && isAnimationModeOpts(timeState.context.modeOpts)) {
    setCurrentAnimationPrefetchContext(
      buildAnimationPrefetchContext({
        windowStart: timeState.context.modeOpts.startTime,
        windowEnd: timeState.context.modeOpts.endTime,
        temporalResolution: timeState.context.modeOpts.temporalResolution,
      }),
    );
    return;
  }

  setCurrentAnimationPrefetchContext(null);
}
